import VueAgile from './Agile.vue'

const install = (Vue) => {
	Vue.component('agile', VueAgile)
}

export default {
	install
}

export { VueAgile }



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-agile/src/index.js
// module id = 6fn2
// module chunks = 0